<template>
    <div class="mt-5 mb-5">
      <vs-table
          ig="mytable"
          :data="searchresult"
          pagination
          :max-items="perPage"
          class="stickyCol-tbl dayinout-tbl"
      >
          <template slot="header">
              <!-- <div class="datepicker-main">
                  <div class="datewrapper">
                      <label for class="float-right w-auto">Select Date</label>
                      <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                          placeholder="Select Date"
                          class="float-right calendar-icon-right top-45"
                          :format="format"
                          v-model="current_date"
                          :disabledDates="disabledDates"
                      ></datepicker>
                  </div>
              </div> -->
              <!-- <div class="flex mb-4">
                  <vue-json-to-csv :json-data="csvData" :csv-title="'DaysData'">
                  <vs-button class="gradient-btn">
                      <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                  </vs-button>
                  </vue-json-to-csv>
                  <vs-button
                  class="ml-1 gradient-btn"
                  target="_blank"
                  title="Download PDF"
                  @click="generatePDF"
                  >
                  <feather-icon icon="FileTextIcon" class></feather-icon>
                  </vs-button>
              </div> -->
          </template>
          <template slot="thead">
              <vs-th style="width: 30%;" class="sticky-col user-col">User</vs-th>
              <vs-th style="width: 10%;" class="sticky-col clockin-col">Clock ON</vs-th>
              <vs-th style="width: 10%;" class="sticky-col total-col">Break Total</vs-th>
              <vs-th style="width: 10%;" class="sticky-col clockout-col">Clock OFF</vs-th>
              <vs-th style="width: 10%;" class="sticky-col total-col">Total Time</vs-th>
              <!-- <vs-th v-if="$store.state.uInfo.role == 'U'" style="width: 10%;" class="sticky-col total-col">Break Start</vs-th>
              <vs-th
                  v-if="$store.state.uInfo.role == 'U'"
                  style="width: 10%;"
                  class="sticky-col total-col"
              >Break End</vs-th> -->
              <!-- <vs-th v-if="$store.state.uInfo.role !== 'U'" class="sticky-col dis-block-text" style="width: 10%;">
                <span class="dis-block">Approved</span> -->
                <!-- <vs-button class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-x" title="Is Approve All?" @click.prevent="confirmApprove(current_date,null)"></vs-button> -->
                <!-- <span class="dis-block cursor-pointer" @click.prevent="confirmApprove(current_date,null)">[ ] All</span>
              </vs-th> -->
              <vs-th
                  v-if="$store.state.uInfo.role !== 'U'"
                  class="sticky-col"
                  style="width: 30%;"
              >Comments</vs-th>
              <!-- <vs-th style="width: 10%;">Action</vs-th> -->
          </template>

          <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                  <vs-td class="sticky-col user-col">
                      <div @click.prevent="openTimesheetSlidebar(tr._id,current_date)">
                        <!-- <vx-tooltip :text="tr.user_name.toUpperCase()"> -->
                            <div class="relative inline-flex float-left">
                              <vs-avatar
                                  class="m-0"
                                  :src="tr.profile_image"
                                  size="40px"
                                  v-if="tr.profile_image"
                              />
                              <vs-avatar
                                  color="primary"
                                  class="m-0 name-avatar"
                                  :text="usernameList(tr.firstname,tr.lastname)"
                                  size="40px"
                                  v-else
                              />
                              <div
                                  class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                                  :class="'bg-success'"
                              ></div>
                            </div>                            
                            <h6 class="pt-3 ml-16 break-words">{{ tr.user_name }}</h6>
                        <!-- </vx-tooltip> -->
                      </div>
                  </vs-td>
                  <vs-td class="sticky-col clockin-col">
                      <span v-if="tr.cin">{{tr.cin.start_time | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm a') }}</span>
                      <span v-else>00:00</span>
                  </vs-td>
                  <vs-td class="sticky-col total-col" >
                      {{convertToTime(tr.totalBreakMinutes)}}
                  </vs-td>     
                  <vs-td class="sticky-col clockout-col">
                      <span v-if="tr.cout">{{tr.cout.start_time | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm a') }}</span>
                      <span v-else>00:00</span>
                  </vs-td>
                  <vs-td class="sticky-col total-col">
                      {{ convertToTime(tr.totalActiveMinutes+tr.totalOutMinutes) }}
                  </vs-td>
                  <!-- <vs-td v-if="$store.state.uInfo.role == 'U'" class="sticky-col total-col">
                      <span v-if="tr.bi">{{tr.bi.start_time | moment('timezone',$store.state.uInfo.timeZone, 'h:mm a') }}</span>
                      <span v-else>00:00</span>
                  </vs-td>
                  <vs-td v-if="$store.state.uInfo.role == 'U'" class="sticky-col total-col">
                      <span v-if="tr.bs">{{tr.bs.start_time | moment('timezone',$store.state.uInfo.timeZone, 'h:mm a') }}</span>
                      <span v-else>00:00</span>
                  </vs-td>               -->
                  <!-- <vs-td v-if="$store.state.uInfo.role !== 'U'"> -->
                    <!-- <vs-button :disabled="!tr.isUnApprovedEditesThere" color="danger" type="filled" icon-pack="feather" icon="icon-x" title="Is Approve?" ></vs-button> -->
                    <!-- <span :disabled="!tr.isUnApprovedEditesThere" class=" dis-block cursor-pointer" @click.prevent="confirmApprove(current_date,tr._id)">[ ]</span> -->
                    <!-- <vs-button disabled color="danger" type="filled" icon-pack="feather" icon="icon-x" v-else></vs-button> -->
                      <!-- <vs-chip color="success" v-if="!tr.isUnApprovedEditesThere">Approved</vs-chip>
                      <div v-else>
                          <feather-icon icon="CheckIcon" class="rounded p-3 inline-flex text-success" ></feather-icon>
                      </div> -->
                  <!-- </vs-td> -->
                  <vs-td v-if="$store.state.uInfo.role !== 'U'">
                  
                    <ul class="faq-topics" v-if="displayEditComments(tr.editComments,tr.users_data).length">
                      <li class="flex items-center" :key="comment_index" v-for="(comm, comment_index) in displayEditComments(tr.editComments,tr.users_data)" v-if="comment_index == 0" >
                        <div class="h-3 w-3 rounded-full mr-2 bg-grey"></div>
                        <span class="cursor-pointer">
                          {{comm | shortName(25)}} 
                          <feather-icon icon="PlusIcon" class="text-success h-3" @click.prevent="show_edit_comments = true, edited_comments = displayEditComments(tr.editComments,tr.users_data)"></feather-icon>
                        </span>
                      </li>
                    </ul>
                    <span v-else>-</span>
                  </vs-td>
              </vs-tr>
          </template>
      </vs-table>
      <!-- Display Edit timesheet List -->
      <vs-popup class="holamundo" title="Comments" :active.sync="show_edit_comments">
        <div class="overflow-auto mb-5">
          <vs-list :key="comment_index" v-for="(comm, comment_index) in edited_comments">
            <vs-list-item :title="comm"></vs-list-item>
          </vs-list>
        </div>
      </vs-popup>
        <div class="dailyTimesheetprintpdf hidden">
            <div id="printpdf">
          <table width="100%" style="border-collapse: collapse;width:100%;margin:0px 10px 10px 10px;" id="pdfHeader">
            <tbody>
             <tr style="border-collapse: collapse;border:0;">
                  <td style="min-width:90px;max-width:90px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;">Daily Timesheet</td>
                  <td style="min-width:100px;max-width:100px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;text-align:right;">{{ $store.state.uInfo.org_name }}</td>
              </tr>
            <tr style="border-collapse: collapse;" v-if="office_id">
              <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;">Office: {{ officepdf }} </td> 
            </tr >
            <tr style="border-collapse: collapse;">
              <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;" colspan="2">Date: <span>{{convertDate(current_date)}}</span></td>
            </tr>
            </tbody>
          </table>
          <table width="100%" style="width:100%;border-collapse: collapse;border:0;margin:0px 10px;" id="dailypdf">
            <thead>
              <tr style="border-collapse: collapse;border:0;">
                  <th style="letter-spacing: 0px;min-width:55px;max-width:55px;font-size:6px;border: 1px solid #abc0e4;border-right:0 !important;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">User</th>
                  <th style="letter-spacing: 0px;min-width:45px;max-width:45px;font-size:6px;border: 1px solid #abc0e4;border-right:0 !important;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">Clock ON</th>
                     <th style="letter-spacing: 0px;min-width:87px;max-width:87px;font-size:6px;border: 1px solid #abc0e4;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">Break Total</th>
                  <th style="letter-spacing: 0px;min-width:87px;max-width:87px;font-size:6px;border: 1px solid #abc0e4;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">Clock OFF</th>
                  <th style="letter-spacing: 0px;min-width:87px;max-width:87px;font-size:6px;border: 1px solid #abc0e4;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">Total Time</th>
               
              </tr>
            </thead>
            <tbody>
              <tr :key="indextr" v-for="(tr, indextr) in searchresult" style="border-collapse: collapse;border:0;">
                <td>{{ tr.firstname | capitalize}} {{tr.lastname | capitalize}}</td>
                <td>  <span v-if="tr.cin">{{tr.cin.start_time | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm a') }}</span>
                      <span v-else>00:00</span>
                </td>
                  <td>
                      {{convertToTime(tr.totalBreakMinutes)}}
                  </td>     
                  <td>
                      <span v-if="tr.cout">{{tr.cout.start_time | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm a') }}</span>
                      <span v-else>00:00</span>
                  </td>
                  <td>
                      {{ convertToTime(tr.totalActiveMinutes+tr.totalOutMinutes) }}
                  </td>
              </tr>
           
            </tbody>
          </table>
        </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from '@/mixins/mixin.js';
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueJsonToCsv from "vue-json-to-csv";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import "fullcalendar/dist/fullcalendar.css";
export default {
  components: {
    Datepicker,
    flatPickr,
    jsPDF,
    vSelect,
    "vue-json-to-csv": VueJsonToCsv,
  },
  props: {
    office_id: {
        required: false,
        default: 'all',
        type: String
    },
    department_id: {
        required: false,
        default: 'all',
        type: Array
    },
    current_date: {
      required: true,
      default: new Date(),
    },
    search: {
      required: false,
      default: null,
    },
    day_current_date:{
      default: null,
    }
  },
  data() {
    return {
      timezone: this.$store.state.uInfo.timeZone,
      // disabledDates: {
      //   from: new Date(
      //     new Date().getFullYear(),
      //     new Date().getMonth(),
      //     new Date().getDate() + 1
      //   ) // Disable all dates after specific date
      // },
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      DailyTimeSheet: [],
      searchresult: [],
      // current_date: new Date(),
      // format: "dd/MM/yyyy",
      csvData: [],
      cur_date: null,
      select_user_id: null,
      show_edit_comments: false,
      show_added_comments:false,
      edited_comments: [],
      added_comments: [],
      departmentpdf:'',
      officepdf:''
    };
  },
  mounted: function() {
    this.getNewDailyTimeSheet();
    /** Reload details when close sidebar */
    EventBus.$on('reload_details', () => {
      this.getNewDailyTimeSheet();
    })
    EventBus.$on("dayTimesheetPDF", () => {
      this.generatePDF();
    });
  },
  watch: {
    office_id(nv) {
      if (nv) {
        this.getOfficeAndDepartment();
      }
        this.getNewDailyTimeSheet();
    },
    department_id(nv) {
      if (nv) {
        this.getNewDailyTimeSheet();
      }
    },
    currentPage(nv) {
      if (nv) {
        // this.getItems();
      }
    },
    perPage(nv) {
      if (nv) {
        // this.getItems();
      }
    },
    current_date(nv) {
      if (nv) {
        this.getNewDailyTimeSheet();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 25;
        this.currentPage = 1;
        this.searchresult = this.DailyTimeSheet;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
      }
      if (nv) {
        if (this.mainTab == 0) {
            let result = this.DailyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.searchresult = result;
        } else {
            // Daily Activity
            let result = this.DailyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.searchresult = result;
        }
      }
    }
  },
  computed: {
  },
  methods: {
    convertDate(date){
      return moment.tz(date, this.timezone).format('DD/MM/YYYY');
    },
    displayEditComments(data,inout){
      let result = [];    
      if(inout.length){
        inout.forEach(element => {
          var d=new Date(element.start_time); 
          if(element.comment){
              let resp = this.manageAddedComment(element.comment,element.main_status,element.status,element.is_clockedIn);
              if(resp){
                if(d.toLocaleDateString()===this.day_current_date.toLocaleDateString()){
                  result.push(resp);    
                }
              }
          }
        });
      }
      
      if(data.length){
        data.forEach(ele => {
          let resp = this.manageComment(ele.main_status,ele.status,ele.new_value,ele.old_value,ele.reason);
          result.push(resp);
        });
      }
      
      return result;
    },
    manageAddedComment(comment,main_status,status,isclockedIn){
      let text = '';
      if (main_status == 'CIN' && status == 'IN' && isclockedIn) {
        text = 'Clock On : ';
        text += comment;
      } 
      else if (main_status == 'COUT' && status == 'OUT') {
        text = 'Clock Off : ';
        text += comment;
      }
      // console.log('text',text);
      return text;
    },
    manageComment(main_status,status,from,to,comment){
      let text = '';
      if (main_status == 'CIN' && status == 'IN') {
        text = 'Clock On time : ';
      } 
      else if (main_status == 'COUT' && status == 'OUT') {
        text = 'Clock Off time : ';
      }
      else if (main_status == 'CIN' && status == 'BI') {
        text = 'Break start time : ';
      } 
      else if (main_status == 'CIN' && status == 'BS') {
        text = 'Break end time : ';
      }
      let from_time =  moment.tz(from, this.timezone).format('hh:mm a');
      let to_time =  moment.tz(to, this.timezone).format('hh:mm a');

      text += 'from '+to_time ;
      text += ' to '+from_time;
      if(comment){
        text +=' - '+comment;
      }
      return text;
    },
    openTimesheetSlidebar(id,current_date){
      let data = {
        id: id,
        current_date: current_date,
        type: 'day',
        isUserTimeSheet:true,
      }
      EventBus.$emit('open_timesheet_sidebar', data);
    },
    /** set avatar name */
    usernameList(firstname, lastname) {
      if (firstname && lastname) {
        let first = firstname.trim().charAt(0);
        let last = lastname.trim().charAt(0);
        let name = first.concat(last);
        return name.toUpperCase();
      }
    },
    generateDayPDF() {
      const doc = new jsPDF();
      var finalY = doc.lastAutoTable.finalY || 10;
      doc.text("DayWise Data of User", 14, finalY + 15);
      doc.autoTable({
        body: this.csvData,
        startY: finalY + 20,
        columns: [
          { header: "User", dataKey: "User" },
          { header: "Status", dataKey: "Status" },
          { header: "Start Time", dataKey: "StartTime" },
          { header: "Notes", dataKey: "Comment" }
        ]
      });
      doc.save("DaysData.pdf");
    },
    generatePDF() {
       const doc = new jsPDF();
      autoTable(doc, { html: '#pdfHeader' })
      autoTable(doc, { html: '#dailypdf' })
      doc.save("DaysData.pdf")
     // const doc = new jsPDF();
      // var finalY = doc.lastAutoTable.finalY || 10;
      // doc.text("DayWise Data of User", 14, finalY + 15);
      // doc.autoTable({
      //   body: this.csvData,
      //   startY: finalY + 20,
      //   columns: [
      //     { header: "User", dataKey: "User" },
      //     { header: "Clock ON", dataKey: "Clock ON" },
      //     { header: "Clock OFF", dataKey: "Clock OFF" },
      //     { header: "Total Time", dataKey: "Total Time" },
      //     { header: "Break Start", dataKey: "Break Start" },
      //     { header: "Break End", dataKey: "Break End" },
      //     { header: "Break Total", dataKey: "Break Total" }
      //   ]
      // });
      // doc.save("DaysData.pdf");
    },
    convertToTime(totalMinutes) {
      if (totalMinutes) {
        const addZero = d => (d > 9 ? d.toString() : "0" + d.toString());
        let hours = addZero(Math.floor(totalMinutes / 60));
        let minutes = addZero(totalMinutes % 60);

        return hours + ":" + minutes;
      } else {
        return "00:00";
      }
    },
    async getNewDailyTimeSheet() {
      this.$vs.loading({
        color: "primary"
      });
      let timezone = this.$store.state.uInfo.timeZone;
      let date = moment.tz(this.current_date, this.timezone).format('DD/MM/YYYY');
      console.log('date of today',date);
      // let url = "inout/getDailyTimeSheet";
      let url = "inout/getDailyTimeSheetMobile";

      url += "?date=" + date + "&mobile=true&fromFront=true&records=records";
      if (this.$store.state.uInfo.role == "U") {
        url += "&user_id=" + this.$store.state.uInfo.id;
      } else {
        let office = this.office_id ? this.office_id : 'all';
        let department = this.department_id ? this.department_id.toString() : ''
        url += "&office_id="+office;
        url += "&department_id="+ department;
      }
      return await this.axios
        .get(url)
        .then(response => {
          console.log('getDailyTimeSheetMobile',response);
            let data = response.data.data;
            console.log('Keyur Data',data);
            let responseOfProgressBar = data.responseOfProgressBar;
            let responseOftimesheet = data.data;
            let timesheetData = [];
            responseOftimesheet.data.forEach(element => {
                let userData = [];
                let current = moment.tz(this.current_date, this.timezone).format('DD/MM/YYYY');
                element.users_data.forEach(element => {
                    let start_date = moment.tz(element.start_time, this.timezone).format('DD/MM/YYYY');
                    if (current == start_date) {
                      console.log('current',current);
                      console.log('startDate',start_date);
                        userData.push(element);
                    }
                });

                element.cin = null;
                element.cout = null;
                element.bi = null;
                element.bs = null;
                element.totalActiveMinutes = 0;
                element.totalBreakMinutes = 0;
                element.totalOutMinutes = 0

                let inout = [];
                if (userData.length != 0) {
                    for (let i = 0; i < userData.length; i++) {
                        if (userData[i].is_clockedIn && !element.cin) {
                        element.cin = userData[i];
                        //   userData.splice(i, 1);
                        } else if (userData[i].is_clockedOut) {
                        element.cout = userData[i];
                        } else if (userData[i].status == "BI") {
                        element.bi = userData[i];
                        } else if (userData[i].status == "BS") {
                        element.bs = userData[i];
                        } else {
                        inout.push(userData[i]);
                        }
                    }
                }
                element.inout = inout;

                /* find total actvie & break time */
                let filter = responseOfProgressBar.findIndex(
                x => x.user_id === element._id
                );
                if (filter >= 0) {
                    element.totalActiveMinutes = responseOfProgressBar[filter].totalActiveMinutes;
                    element.totalBreakMinutes = responseOfProgressBar[filter].totalBreakMinutes;
                     element.totalOutMinutes = responseOfProgressBar[filter].totalOutMinutes;
                }
                /* find total actvie & break time */
                timesheetData.push(element);
            });
            if (timesheetData && timesheetData.length) {     
                /* stat check inout length */
                let len = timesheetData[0].inout.length;
                timesheetData.forEach(el => {
                    if (el.inout.length > len) {
                        len = el.inout.length;
                    }
                });
                /* end check inout length  */
                if (len) {
                    timesheetData.forEach(ell => {
                    for (let q = 0; q < len; q++) {
                        if (!ell.inout[q]) {
                        ell.inout[q] = {
                            is_blank: false
                        };
                        }
                    }
                    });
                } else {
                    timesheetData.forEach(ell => {
                        for (let q = 0; q < 4; q++) {
                            if (!ell.inout[q]) {
                                ell.inout[q] = {
                                    is_blank: false
                                };
                            }
                        }
                    });
                }
            }
            this.DailyTimeSheet = timesheetData;
            this.searchresult = timesheetData;

            for (let i = 0; i < timesheetData.length; i++) {
                const element = timesheetData[i];
                const cout_time =
                element.cout && element.cout.start_time
                    ? moment.tz(element.cout.start_time, this.timezone).format('hh:mm a')
                    : "00:00";
                const cin_time =
                element.cin && element.cin.start_time
                    ? moment.tz(element.cin.start_time, this.timezone).format('hh:mm a')
                    : "00:00";
                const bi_time =
                element.bi && element.bi.start_time
                    ? moment.tz(element.bi.start_time, this.timezone).format('hh:mm a')
                    : "00:00";
                const bs_time =
                element.bs && element.bs.start_time
                    ? moment.tz(element.bs.start_time, this.timezone).format('hh:mm a')
                    : "00:00";
                const break_total = element.totalBreakMinutes
                ? this.convertToTime(element.totalBreakMinutes)
                : "00:00";
                const total_time = element.totalActiveMinutes? this.convertToTime(element.totalActiveMinutes+element.totalOutMinutes)
                : "00:00";
                let myobj = {
                User: element.firstname + " " + element.lastname,
                "Clock ON": cin_time,
                "Clock OFF": cout_time,
                "Total Time": total_time,
                "Break Total": break_total
                };
                this.csvData.push(myobj);
            }
            this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmApprove(cur_date,user_id = null) {
      this.cur_date = cur_date;
      this.select_user_id = user_id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to approve timesheet changes?",
        acceptText: "Approve",
        accept: this.approveTimeSheetChanges
      });
    },
    approveTimeSheetChanges() {
      let office = this.office_id ? this.office_id : 'all';
      let department = this.department_id ? this.department_id : 'all'
      let input = {
        which: 'D',
        date: moment(this.cur_date).format("DD/MM/YYYY"),
        office_id: office,
        department_id: department,
        timeZone: this.timezone,
        user_id: this.select_user_id
      };
      this.$vs.loading({color: "primary"});
      this.axios
        .post("user/approveTimeSheetChanges", input)
        .then(response => {
          if (response) {            
            this.$vs.loading.close();
            let text = "Timesheet has been approved successfully!!!";
            this.$vs.notify({
              text: text,
              color: "success",
              position: "top-right"
            });
            this.getNewDailyTimeSheet();
          }
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
      this.$vs.loading.close();
    },
    getOfficeAndDepartment(){
      if(this.office_id){
          this.$vs.loading({ color: "primary" });
          let url = "office/getAll";
          this.axios
            .get(url)
            .then(response => {
              this.$vs.loading.close();
              let data = response.data.data;
              let selectedOffice = data.filter((i) => i.id == this.office_id);
              this.officepdf = selectedOffice[0].office_name;
            })
            .catch(e => {
              this.showError(e);
            });
        
      }
      // if(this.department_id){
      //   this.$vs.loading({ color: "primary" });
      //   let url = "dept/getAll";
      //   this.axios
      //     .get(url)
      //     .then(response => {
      //       let data = response.data.data;
      //           let selectedOffice = this.officesList.filter((i) => i.id == this.office_id);
      //         this.departmentpdf = defaultOffice[0].department_name;
      //      this.$vs.loading.close();
      //     })
      //     .catch(e => {
      //       this.showError(e);
      //     });
      // }
    }
  },
  destroyed() {
    EventBus.$off('dayTimesheetPDF');
    EventBus.$off('reload_details');
  },
  filters: {
    display_time(time) {
      return time;
    }
  }
};
</script>